import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { inject } from '@angular/core';

export const MaintenanceGuard: CanActivateFn = (route, state) => {
	const isMaintenance: boolean = environment.maintenance;

	if (!isMaintenance) return true;
	else {
		return inject(Router).createUrlTree(['/maintenance']);
	}
};
